enum ProductEnum {
	HAP = 'hap',
	CCG = 'ccg',
	CLINIPAM = 'clinipam',
	GNDI_MINAS = 'gndiminas',
	GNDI = 'gndi',
	NOTREDAME_SAUDE = 'notredame',
}

enum ProductKeyByHostEnum {
	HAP = 'beneficiario',
	CCG = 'ccg',
	CLINIPAM = 'clinipam',
	GNDI_MINAS = 'gndiminas',
	GNDI = 'gndi',
	NOTREDAME_SAUDE = 'notredame',
}

const keysByHost: Record<ProductKeyByHostEnum, string> = {
	ccg: 'ccg',
	clinipam: 'clinipam',
	gndiminas: 'gndiminas',
	gndi: 'gndi',
	notredame: 'notredame',
	beneficiario: 'hapvida',
};

const PRODUCT_CODE: Record<ProductEnum, number[]> = {
	[ProductEnum.HAP]: [1, 3],
	[ProductEnum.CCG]: [8],
	[ProductEnum.CLINIPAM]: [9],
	[ProductEnum.GNDI_MINAS]: [10],
	[ProductEnum.GNDI]: [14],
	[ProductEnum.NOTREDAME_SAUDE]: [14],
};

const PRODUCT_NAME: Record<ProductEnum, string> = {
	[ProductEnum.HAP]: 'Hapvida',
	[ProductEnum.CCG]: 'Hapvida',
	[ProductEnum.CLINIPAM]: 'Hapvida Clinipam',
	[ProductEnum.GNDI_MINAS]: 'Hapvida',
	[ProductEnum.GNDI]: 'Hapvida',
	[ProductEnum.NOTREDAME_SAUDE]: 'NotreDame Saúde',
};

const AD_SERVER_PRODUCT_NAME: Record<ProductEnum, string> = {
	[ProductEnum.HAP]: 'Hapvida',
	[ProductEnum.CCG]: 'CCG',
	[ProductEnum.CLINIPAM]: 'Clinipam',
	[ProductEnum.GNDI_MINAS]: 'NDI Minas',
	[ProductEnum.GNDI]: 'GNDI',
	[ProductEnum.NOTREDAME_SAUDE]: 'NotreDame Saúde',
};

const PRODUCT_FOOTER_NAME: Record<ProductEnum, string> = {
	[ProductEnum.HAP]: 'Hapvida',
	[ProductEnum.CCG]: 'Hapvida',
	[ProductEnum.CLINIPAM]: 'Hapvida Clinipam',
	[ProductEnum.GNDI_MINAS]: 'Hapvida',
	[ProductEnum.GNDI]: 'Hapvida',
	[ProductEnum.NOTREDAME_SAUDE]: 'NotreDame Saúde',
};

const PRODUCT_LINK_IOS_STORE: Record<ProductEnum, string> = {
	[ProductEnum.HAP]: 'https://apps.apple.com/br/app/haplicativo/id1550782810',
	[ProductEnum.CCG]: 'https://apps.apple.com/br/app/ccg/id1567285124',
	[ProductEnum.CLINIPAM]: 'https://apps.apple.com/br/app/clinipam/id1343889691',
	[ProductEnum.GNDI_MINAS]: 'https://apps.apple.com/br/app/hapvida-ndi-minas/id1513433257',
	[ProductEnum.GNDI]: 'https://apps.apple.com/br/app/id1430190022',
	[ProductEnum.NOTREDAME_SAUDE]: 'https://apps.apple.com/br/app/notredame-saude/id6786002017',
};

const PRODUCT_LINK_ANDROID_STORE: Record<ProductEnum, string> = {
	[ProductEnum.HAP]: 'https://play.google.com/store/apps/details?id=br.com.hapvida.hapvida&pli=1',
	[ProductEnum.CCG]: 'https://play.google.com/store/apps/details?id=com.ccgmobile',
	[ProductEnum.CLINIPAM]:
		'https://play.google.com/store/apps/details?id=br.com.mobilesaude.clinipam',
	[ProductEnum.GNDI_MINAS]: 'https://play.google.com/store/apps/details?id=com.solusvitallis',
	[ProductEnum.GNDI]:
		'https://play.google.com/store/apps/details?id=br.com.gndi.beneficiario.gndieasy&hl=pt_BR',
	[ProductEnum.NOTREDAME_SAUDE]:
		'https://play.google.com/store/apps/details?id=com.notredame.notredamesaude&hl=pt_BR',
};

const PRODUCT_LINK_OMBUDSMAN: Record<ProductEnum, string> = {
	[ProductEnum.HAP]: 'https://www2.hapvida.com.br/ouvidoria',
	[ProductEnum.CCG]: 'https://www.ccgsaude.com.br/ouvidoria',
	[ProductEnum.CLINIPAM]: 'https://www.gndisul.com.br/ouvidoria',
	[ProductEnum.GNDI_MINAS]: 'https://www.gndiminas.com.br/ouvidoria',
	[ProductEnum.GNDI]: 'https://www.gndi.com.br/ouvidoria',
	[ProductEnum.NOTREDAME_SAUDE]: 'https://www.notredame.com.br/ouvidoria',
};

const ANS_REGISTER = {
	[ProductEnum.HAP]: '368253',
	[ProductEnum.GNDI]: '359017',
	[ProductEnum.GNDI_MINAS]: '348520',
	[ProductEnum.CLINIPAM]: '340782',
	[ProductEnum.CCG]: '392804',
	[ProductEnum.NOTREDAME_SAUDE]: '359017',
};

export {
	PRODUCT_CODE,
	PRODUCT_NAME,
	ProductEnum,
	PRODUCT_FOOTER_NAME,
	ProductKeyByHostEnum,
	keysByHost,
	PRODUCT_LINK_IOS_STORE,
	PRODUCT_LINK_ANDROID_STORE,
	PRODUCT_LINK_OMBUDSMAN,
	ANS_REGISTER,
	AD_SERVER_PRODUCT_NAME,
};
